import React from 'react';
import { Body2 } from '../../../typography';
import { FormHelperText } from '../../../form-helper-text';
import { FileName, FileInfoWrap } from './styled';
import { formatFileSize } from '../../utils';
const FileInfoCaption = ({ fileState, errorMessage, fileSizeByte, hasError }) => {
    if (hasError && errorMessage) {
        return (React.createElement(FormHelperText, { msgType: "error", icon: null }, errorMessage));
    }
    if ((fileState === null || fileState === 'done') && fileSizeByte) {
        return React.createElement(Body2, { "$shade": "mediumEmphasis" }, formatFileSize(fileSizeByte));
    }
    return null;
};
export const FileInfo = ({ fileName, fileSizeByte, fileState, errorMessage, hasError }) => {
    return (React.createElement(FileInfoWrap, { title: fileName },
        React.createElement(FileName, null, fileName),
        React.createElement(FileInfoCaption, { hasError: hasError, fileState: fileState, fileSizeByte: fileSizeByte, errorMessage: errorMessage })));
};
